import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var contourLegend = {
  name: "odz94x",
  styles: "margin-top:5px;"
};
export var contourLegendContainer = /*#__PURE__*/css(media('>=desktop'), "{margin-top:25px;}");
export var contourLabel = /*#__PURE__*/css("display:inline-block;vertical-align:top;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colour.neutral700, ";margin-left:16px;");
export var twoMetreContour = /*#__PURE__*/css("display:inline-block;width:100px;height:16px;margin-right:5px;overflow:hidden;position:relative;&::before{content:'';border-radius:100% 50%;width:100px;height:50px;position:absolute;border:1px solid ", colour.neutral700, ";}");
export var tenMetreContour = /*#__PURE__*/css(twoMetreContour, ";&::before{border-width:5px;}");